function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 10");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Learning-System",
  stroke: "current",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Notifications",
  transform: "translate(-903.000000, -44.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10",
  transform: "translate(902.000000, 44.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(0.000000, 1.157895)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.7894433,0 C10.7894433,0 10.7894433,0 10.7894433,0 C10.7894433,0 10.7894433,0 10.7894433,0 C15.0339406,-7.7970151e-16 18.4747855,3.44084493 18.4747855,7.68534226 C18.4747855,7.98478437 18.4572849,8.28397056 18.4223681,8.58136993 L17.9749749,12.3925449 C17.7536731,14.277732 18.3457702,16.1679442 19.6030383,17.5899787 C20.09482,18.1462088 20.0425741,18.9957902 19.486344,19.4875719 C19.2406042,19.7048386 18.9239081,19.8247639 18.5958946,19.8247639 L3.05944667,19.8247639 C2.32607426,19.8247639 1.73155845,19.2302481 1.73155845,18.4968757 C1.73155845,18.1601279 1.85949943,17.8359575 2.08948535,17.5899787 C3.4125572,16.1749023 4.03373618,14.2424405 3.78301552,12.3214774 L3.2897475,8.5421729 C2.74912257,4.40019635 5.66861437,0.604212786 9.8105937,0.0636090921 C10.1351568,0.0212477051 10.4621274,6.01269466e-17 10.7894433,0 Z",
  id: "Rectangle"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.10526316,19.6842105 C8.10526316,19.8695586 8.11736023,20.0515162 8.14065862,20.2290083 C8.35851243,21.8886655 9.55573772,23.1578947 11,23.1578947 C12.4768244,23.1578947 13.6953469,21.8307886 13.8725746,20.1161679 C13.8872027,19.974646 13.8947368,19.8304841 13.8947368,19.6842105",
  id: "Path"
})))));

var SvgBellIcon = function SvgBellIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "25px",
    viewBox: "0 0 20 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBellIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell-icon.d7d8948c.svg";
export { ForwardRef as ReactComponent };